import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/lib/site";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35M12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88m8.41-18.3A11.81 11.81 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41" />
  </svg>
);

export const FloatingCtas = () => {
  const { pathname } = useLocation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.4, duration: 0.6 }}
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex items-center gap-2"
    >
      {pathname !== "/quote" && (
        <Link to="/quote" data-testid="floating-quote-button"
          className="rounded-full bg-[var(--navy)] px-5 py-3.5 text-sm font-semibold text-white shadow-2xl shadow-slate-900/30 transition-transform duration-300 hover:-translate-y-0.5">
          Free quote
        </Link>
      )}
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp-button" aria-label="Message us on WhatsApp"
        className="flex items-center gap-2 rounded-full bg-[#1FAF5A] px-5 py-3.5 text-sm font-semibold text-white shadow-2xl shadow-green-900/30 transition-transform duration-300 hover:-translate-y-0.5">
        <WaIcon /> <span className="hidden sm:inline">WhatsApp us</span>
      </a>
    </motion.div>
  );
};
